import ExpenseRepository from '@/shared/http/repositories/business/expense.js'
import ModalHistory from '../modalhistory/ModalHistory.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'TableTravelComision',
  mixins: [ActionsForm],
  data () {
    return {
      datadespesa: [],
      valueTotalFinal: null,
      dataSituacao: [],
      dataFilter: localStoreHelper.reembolsoViagem.adiantamentoPrestacao() || {},
      isAllChecked: false,
      opcoesGrupoReembolso: []
    }
  },
  components: {
    ModalHistory
  },
  props: {
    selectedIds: {
      type: Array,
      default: []
    }
  },
  mounted () {
    this.getAll()
    this.getStatusAdiantamento()
  },
  methods: {
    onDeleteBoard (obj) {
      loading.push()
      ExpenseRepository.Delete(obj.id)
        .then(Response => {
          loading.pop()
          // JsonReturn responde HTTP 200 sempre; -400 = exclusão recusada pelo back (ZC-80: adiantamento já pago em lote).
          const r = Response.data
          if (!r || r.code !== 200) {
            this.$bvModal.msgBoxOk((r && r.message) || 'Não foi possível excluir a prestação.', { title: 'Prestação não excluída', okVariant: 'danger' })
            return
          }
          this.getAll()
          this.getStatusAdiantamento()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    loadPersistentSelectedIds () {
      let inputs = document.querySelectorAll('.checkboxInput')
      inputs.forEach((i) => {
        if (this.selectedIds.includes(i.id)) {
          i.checked = true
        } else {
          i.checked = false
        }
      })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    checkAll () {
      let inputs = document.querySelectorAll('.checkboxInput')
      if (!this.isAllChecked) {
        inputs.forEach((i) => {
          i.checked = true
          this.$emit('selectedId', i.id)
        })
        this.isAllChecked = true
      } else {
        inputs.forEach((i) => {
          i.checked = false
          this.$emit('selectedId', i.id)
        })
        this.isAllChecked = false
      }
    },
    verificarFilterDataViagem (obj) {
      if (Object.keys(this.dataFilter).length > 0) {
        if (this.dataFilter.situacao !== undefined) {
          return this.dataFilter.situacao === -10 ? obj.diasDepoisViagem : false
        }
      }
      return false
    },
    getAll (obj = {}) {
      // Aba aberta direto na URL (favorito, link de fora, colar endereco) fica logada pelo cookie
      // zcloud_token mas sem empresa: `company` mora no sessionStorage, que nao atravessa aba, e o
      // handoff de main.js:55 so cobre ctrl/meio/botao-direito em link interno. Sem esse guard a
      // busca ia sem empresa e a tela ficava vazia sem explicar por que.
      if (!this.CompanySelected) {
        this.datadespesa = []
        toast.warning('Selecione a empresa no topo da tela para carregar a prestação de contas.')
        return
      }
      loading.push()
      ExpenseRepository.GetAllDespesas(this.dataFilter, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.CompanySelected)
        .then(Response => {
          loading.pop()
          this.datadespesa = Response.data.data
          this.datadespesa.forEach(x => {
            let valorTotal = 0
            if (x.situacao === 0 || x.situacao === 1) {
              x.despesaItens.forEach((x2) => {
                if (x2.forma === 0 && x2.situacao === 1) valorTotal += x2.valorTotalFinal
              })
            } else {
              x.despesaItens.forEach((x2) => {
                if (x2.situacao === 1) {
                  if (x2.forma === 0) valorTotal += x2.valorTotalFinal
                }
              })
            }
            // console.log(valorTotal)

            x.valorTotal = valorTotal
          })
          this.onResultGrid(Response)
        })
        .catch(Error => loading.pop()).finally(() => { this.loadPersistentSelectedIds() })
    },
    verificarStatus (situacao) {
      if (this.dataSituacao.length > 0) {
        let sit = this.dataSituacao.find((Element) => parseInt(Element.value) === situacao)
        if (sit !== undefined) {
          return sit.text
        }
      }
      return 'N/D'
    },
    setFormaCityState (obj) {
      let result = null
      if (obj && obj.estado) {
        result = obj.nome + ' ' + obj.estado.sigla
      } else {
        result = obj.nome
      }
      return result
    },
    showHistory () {
      this.$refs['ModalHistoryTwo'].show()
    },
    onEdit (obj) {
      this.$emit('editAcount', obj)
    },

    ImportExcelByIds () {
      let lstCheked = this.selectedIds
      if (lstCheked.length > 0) {
        loading.push()
        ExpenseRepository.ImportExcelByIds(lstCheked)
          .then((Response) => {
            loading.pop()
            const obj = Response.data
            const contentType = obj.contentType
            const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(new Blob([data], { type: contentType }))
            a.download = obj.name
            document.body.appendChild(a)
            a.click()
            toast.success('Arquivo gerado com sucesso!')
            loading.close()
            this.onLoad()
          })
          .catch((Error) => {
            loading.pop()
          })
      } else {
        toast.info('Selecionar pelos menos uma prestação de contas')
      }
    },
    CreateExcel (Response) {
      const obj = Response.data
      const contentType = obj.contentType
      const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
      var a = window.document.createElement('a')
      a.href = window.URL.createObjectURL(new Blob([data], { type: contentType }))
      a.download = obj.name
      document.body.appendChild(a)
      a.click()
      toast.success('Arquivo gerado com sucesso!')
      loading.close()
      this.objList.forEach(element => {
        element.checked = false
      })
    },
    importDes (name, reembolso = false) {
      let lstCheked = this.selectedIds
      if (lstCheked.length > 0) {
        loading.push()
        ExpenseRepository.ImportDes(name, reembolso, lstCheked)
          .then(Response => {
            this.CreateExcel(Response)
            this.getAll()
            loading.pop()
          })
          .catch(Error => {
            loading.pop()
            toast.error(Error.response.data)
          })
      }
    },
    onPrint () {
      loading.push()

      const objSelected = this.objList.filter(e => e.checked).map(e => e.id)

      if (objSelected.length > 0) {
        ExpenseRepository.Print(objSelected)
          .then((response) => {
            if (response.data.code > 0) {
              let pdfWindow = window.open('Despesa-Diversos.pdf')
              let pdf = encodeURI(response.data.data)
              pdfWindow.document.write(`
                <embed width="100%" height="100%" src="data:application/pdf;base64,${pdf}"></embed>
              `)
            }
          })
          .catch(this.onException)
      } else {
        toast.warning('Você precisa selecionar algum registro!')
      }

      loading.close()
    },
    getStatusAdiantamento () {
      loading.push()
      ExpenseRepository.GetEnumSituacao()
        .then(Response => {
          loading.pop()
          this.dataSituacao = Response.data
        })
        .catch(Error => loading.pop())
    },
    onExportExcel () {
    },
    Print () {
    },
    SaveFile () {
    },
    onDownload () {
    },
    calculoValor (e) {
      if (e.motivoViagem.venda === true) {
        return 'Venda'
      } else {
        if (e.valorTotal > e.valorSolicitado) {
          return 'Reembolso'
        } else if (e.valorTotal < e.valorSolicitado) {
          return 'Desconto'
        } else {
          return ''
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/TableTravelComision/TableTravelComision.js